import {AfterViewInit, Component, Input}             from '@angular/core';
import {CompositeFilterDescriptor, FilterDescriptor} from '@progress/kendo-data-query';
import {FilterService}                               from '@progress/kendo-angular-grid';
import {get}                                         from 'lodash';

type StatusFilterItem = {
  Value: number;
  Class: string;
};

@Component({
  selector: 'ap-status-filter',
  templateUrl: './ap-status-filter.component.html'
})
export class ApStatusFilterComponent implements AfterViewInit {
  @Input() public currentFilter: CompositeFilterDescriptor;
  @Input() public filterService: FilterService;
  @Input() public items: any[];
  @Input() public statusKey: string;
  @Input() public statusClass: string;

  public data: StatusFilterItem[];
  public value: any;

  public ngAfterViewInit(): void {
    if (!this.items || this.items?.length === 0) {
      return;
    }
    this.data = this.getData(this.items);
    this.value = this.currentFilter.filters.map((filterDescriptor: FilterDescriptor) => filterDescriptor.value);
  }

  public onChange(values: any[]): void {
    this.filterService.filter({
      logic: 'or',
      filters: values.map(value => ({
        field: this.statusKey,
        operator: value === null ? 'isnull' : 'eq',
        value
      }))
    });
  }

  private getData(items: any[]): StatusFilterItem[] {
    const uniqueItems = items.reduce((acc: StatusFilterItem[], currentItem: any) => {
      const value = get(currentItem, this.statusKey);
      const classValue = get(currentItem, this.statusClass);
      const exists = acc.some((item: StatusFilterItem) =>
        item.Value === value && item.Class === classValue
      );
      if (!exists) {
        acc.push({Value: value, Class: classValue});
      }
      return acc;
    }, [] as StatusFilterItem[]);
    return uniqueItems.sort();
  }
}
